export const GetFileUrl = (key?: string): string | undefined => {
  if (key == null || key === '') {
    return undefined
  }

  return `${process.env.REACT_APP_BACKEND_URL ?? ''}/File/${key}`
}

export const GetFileDownloadUrl = (key?: string): string | undefined => {
  if (key == null || key === '') {
    return undefined
  }

  return `${process.env.REACT_APP_BACKEND_URL ?? ''}/File/Download/${key}`
}

export const GetFileName = (key?: string): string | undefined => {
  if (key == null || key === '') {
    return undefined
  }

  // The first part of the key is a folder, followed by a guid and an underscore, then the file name
  const parts = key.split('/')
  return parts[1].substring(37)
}
